import React, { Component } from "react";
// import { Document, Page } from "react-pdf";
// import FloatingActionButton from "material-ui/FloatingActionButton";
// import ContentAdd from "material-ui/svg-icons/content/add";
// import ContentRemove from "material-ui/svg-icons/content/remove";
import "./styles.css";
import PDFObject from "pdfobject";
import Data from "./revistasData";
import NotFound from "../../components/notFound";

export default class RenderPDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      scale: 1
    };
    this.routeParam = this.props.match.params;
  }
  componentWillMount() {}
  componentDidMount() {
    const article = this.findArticle();
    if (article) {
      PDFObject.embed(article.pdfLocation, "#pdf-viewer");
    }
  }
  // Article ids are not contiguous (e.g. Axon 2 skips 4, 6 and 11), so match the
  // article by its own location instead of using the id as an array index.
  findArticle() {
    const { type, numero, contenido } = this.routeParam;
    const issue = Data[type] && Data[type][numero];
    if (!issue || !issue.revistas) return null;
    const location = `/revistas/${type}/${numero}/${contenido}`;
    return issue.revistas.find(item => item.location === location) || null;
  }
  // onDocumentLoad({ numPages }) {
  //   this.setState({ numPages });
  // }
  changeZoom(route) {
    if (route && this.state.scale <= 3) {
      this.setState({ scale: this.state.scale + 0.5 });
    }
    if (!route && this.state.scale >= 0.1) {
      this.setState({ scale: this.state.scale - 0.5 });
    }
  }
  render() {
    // const { numPages } = this.state;
    if (!this.findArticle()) return <NotFound />;
    return (
      <div
        className="navMargin"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "100%"
        }}
        id="pdf-viewer"
      >
        {/* <header
          style={{
            padding: 20,
            boxShadow: "0 0 8px rgba(0, 0, 0, .5)",
            backgroundColor: "rgb(50, 54, 57)",
            color: "white"
          }}
        >
          <h1 style={{ maring: 0 }}>Axon (revista)</h1>
          <div style={{ position: "absolute", right: 20, zIndex: 10 }}>
            <FloatingActionButton
              style={{ marginRight: 20 }}
              onClick={this.changeZoom.bind(this, true)}
            >
              <ContentAdd />
            </FloatingActionButton>
            <FloatingActionButton
              style={{ marginRight: 20 }}
              onClick={this.changeZoom.bind(this, false)}
            >
              <ContentRemove />
            </FloatingActionButton>
          </div>
        </header>
        <div
          style={{
            backgroundColor: "rgb(82, 86, 89)",
            alignItems: "center",
            paddingTop: 30,
            paddingBottom: 30,
            height: "100%",
            overflow: "scroll"
          }}
        >
          <Document
            file={require("./../../pdf/Axon_1/Axon_1.pdf")}
            onLoadSuccess={this.onDocumentLoad.bind(this)}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={this.state.scale}
              />
            ))}
          </Document>
          <p>
            Page {pageNumber} of {numPages}
          </p>
        </div> */}
      </div>
    );
  }
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/revistas/renderPDF.js